import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFound } from './pages/not-found/not-found';

const routes: Routes = [
    { 
        path: 'document', 
        loadChildren: () => import('./pages/documents/document.module').then(m => m.DocumentModule)
    },
    { 
        path: '', 
        component: NotFound 
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRoutingModule { }
